module.exports = __webpack_public_path__ + "1e9adb163e096750733f2ff8a0718cbf.pdf";